import styled from '@emotion/styled';
import { IconAndroidTv, IconAndroid, IconIOS, IconSmartTv, IconWeb } from 'common/icons';
import { Box, Button, Flex, Icon, Text, Row, Link, Image } from 'common/styles';
import { __t } from 'common/i18n';
import { FC, ReactNode } from 'react';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
const TV_BASE_URL = publicRuntimeConfig.NEXT_PUBLIC_TV_ANDROID;
const APP_BASE_URL = publicRuntimeConfig.NEXT_PUBLIC_APP_ANDROID;

export default function DownloadApps() {
  return (
    <>
      <Text variant="h2" align="center" mb={{ xs: 2, md: 4 }}>
        {__t('static.download.apps.title')}
      </Text>
      <Text variant="body1" mb={{ xs: 4, md: 7 }}>
        {__t('static.download.apps.description')}
      </Text>

      <FlexWrapper nowrap direction={{ xs: 'column', md: 'row' }}>
        <Box>
          <PlatformSection type="smartTv" title="static.download.apps.smart.tv" buttons={platformButtons.smartTv} />
          <PlatformSection type="androidTv" title="static.download.apps.android.tv" buttons={platformButtons.androidTv} />
          <PlatformSection type="android" title="static.download.apps.android" buttons={platformButtons.android} />
          <PlatformSection type="ios" title="static.download.apps.ios" buttons={platformButtons.ios} />
        </Box>

        <Box pr={5} className="desktop-only">
          <Image src="/static/images/static_pages/devices.png" />
        </Box>
      </FlexWrapper>
    </>
  );
}

const platformButtons: Record<PlatformType, DownloadButtonProps[]> = {
  smartTv: [
    {
      href: 'https://tv.filmnet.ir/',
      icon: <IconWeb />,
      title: 'static.download.apps.for.tv',
    },
  ],
  android: [
    // {
    //   title: 'static.download.apps.google.play',
    //   href: 'https://play.google.com/store/apps/details?id=ir.magicmirror.filmnet.play',
    //   target: '_blank',
    //   image: {
    //     src: '/static/images/google-play-logo.png',
    //     alt: 'google-play-logo',
    //   },
    // },
    {
      title: 'static.download.apps.straight',
      href: `${APP_BASE_URL}?timestamp=${Date.now()}`,
      image: {
        src: '/static/images/filmnet-icon.svg',
        alt: 'filmnet-icon',
      },
    },
    {
      title: 'static.download.apps.cafe.bazaar',
      href: 'https://cafebazaar.ir/app/ir.filmnet.android',
      target: '_blank',
      image: {
        src: '/static/images/bazaar-logo.png',
        alt: 'bazaar-logo',
      },
    },

    {
      title: 'static.download.apps.myket',
      href: 'https://myket.ir/app/ir.filmnet.android',
      target: '_blank',
      image: {
        src: '/static/images/myket-logo.png',
        alt: 'myket-logo',
      },
    },
  ],
  ios: [
    {
      title: 'static.download.apps.sib.app',
      href: 'https://sibapp.com/applications/filmnet',
      target: '_blank',
      image: {
        src: '/static/images/sib-app-logo.svg',
        alt: 'sib-app',
      },
    },

    // {
    //   title: 'static.download.apps.sibirani',
    //   href: 'https://sibirani.com/apps/Filmnet/',
    //   target: '_blank',
    //   image: {
    //     src: '/static/images/Sibe-Irani-logo.svg',
    //     alt: 'Sibe Irani',
    //   },
    // },
    // {
    //   title: 'static.download.apps.iApps',
    //   href: 'https://iapps.ir/app/%D9%81%DB%8C%D9%84%D9%85-%D9%86%D8%AA-filmnet/496646389',
    //   target: '_blank',
    //   image: {
    //     src: '/static/images/iApps-logo.png',
    //     alt: 'iApps',
    //   },
    // },
    // {
    //   title: 'static.download.apps.sibcheh',
    //   href: 'https://sibche.com/applications/filmnet-2',
    //   target: '_blank',
    //   image: {
    //     src: '/static/images/sibche-logo.png',
    //     alt: 'sibche',
    //   },
    // },
    {
      title: 'static.download.apps.appstar',
      href: 'https://app-star.store/app.php?id=filmnet',
      target: '_blank',
      image: {
        src: '/static/images/appstar-logo.svg',
        alt: 'app-star',
      },
    },

  ],
  androidTv: [
    // {
    //   title: 'static.download.apps.google.play',
    //   href: 'https://play.google.com/store/apps/details?id=ir.magicmirror.filmnet.play&hl=en&gl=US',
    //   target: '_blank',
    //   image: {
    //     src: '/static/images/google-play-logo.png',
    //     alt: 'google play',
    //   },
    //   helperText: 'static.download.apps.get.from.smart.tv',
    // },
    {
      title: 'static.download.apps.straight',
      href: `${TV_BASE_URL}?timestamp=${Date.now()}`,
      image: {
        src: '/static/images/filmnet-icon.svg',
        alt: 'filmnet',
      },
    },
    {
      title: 'static.download.apps.cafe.bazaar',
      href: 'https://cafebazaar.ir/app/ir.filmnet.android.tv',
      target: '_blank',
      image: {
        src: '/static/images/bazaar-logo.png',
        alt: 'bazaar-logo',
      },
    },
    {
      title: 'static.download.apps.myket',
      href: 'https://myket.ir/app/ir.filmnet.android.tv',
      target: '_blank',
      image: {
        src: '/static/images/myket-logo.png',
        alt: 'myket-logo',
      },
    },
    {
      title: 'static.download.apps.netstore',
      href: 'https://netstore.app/application/filmnet--lKGzmE',
      target: '_blank',
      image: {
        src: '/static/images/netstore-logo.svg',
        alt: 'netstore-logo',
      },
    },
  ],
  web: [],
};

const PlatformSection = ({ type, title, buttons }: { type: PlatformType; title: string; buttons: DownloadButtonProps[] }) => (
  <>
    <PlatformTitle type={type} title={title} />
    <Row pr={{ md: 5 }} cols={{ xs: 1, sm: 2, md: 2 }}>
      {buttons.map((props, idx) => (
        <DownloadButton key={idx} {...props} />
      ))}
    </Row>
  </>
);

const PlatformTitle = ({ type, title }: { type: PlatformType; title: string }) => (
  <Text variant="body1" mb={3} mt={5}>
    <PlatformIcon type={type} />
    {__t(title)}
  </Text>
);

const PlatformIcon = ({ type }: { type: PlatformType }) => {
  const IconComponent = platformIcons[type];
  return (
    <Icon size="large" ml={2} >
      <IconComponent />
    </Icon>
  );
};

const DownloadButton = ({ href, target, image, icon, title, helperText }: DownloadButtonProps) => {
  const img = image && <Image alt={image.alt} src={image.src} />;

  return (
    <>
      <CustomButton fullWidth iconStart py={2} as={Link} href={href} target={target}>
        <Icon cursor="pointer">{img || icon}</Icon>
        {__t(title)}
      </CustomButton>
      {helperText && (
        <Text variant="body3" as="div" color="weak" mt=".25em">
          {__t(helperText)}
        </Text>
      )}
    </>
  );
};

const platformIcons: Record<PlatformType, FC> = {
  androidTv: IconAndroidTv,
  android: IconAndroid,
  ios: IconIOS,
  smartTv: IconSmartTv,
  web: IconWeb,
};

const FlexWrapper = styled(Flex)(() => ({
  '& > div': {
    flex: 1,
  },
}));

const CustomButton = styled(Button)<{ target?: string }>(({ theme }) => ({
  textAlign: 'right',
  border: '1px solid',
  borderColor: theme.rgba(theme.palette.foreground[900][0], 0.3),
  ...theme.font.responsiveSize(1),
  paddingLeft: theme.spacing(1),
  transition: 'border-color .3s ease',
  [`${Icon}`]: {
    fontSize: '1.5em',
  },
  '&:hover, &:active': {
    borderColor: theme.palette.foreground[900][0],
  },
}));

type PlatformType = 'web' | 'android' | 'ios' | 'smartTv' | 'androidTv';

interface DownloadButtonProps {
  href: string;
  image?: { src: string; alt?: string };
  icon?: ReactNode;
  title: string;
  helperText?: string;
  target?: string;
}
